import React from 'react';
import { useProduct } from 'src/services/products';
import styles from './ProductImage.module.scss';
import Icon from '../Icon/Icon';
import Image from '../Image/Image';

export interface ProductImageProps {}

const ProductImage = ({ id }: { id: number }) => {
  const { productImage } = useProduct(id);
  return (
    <div className={styles.root}>
      <Image imageUrl={productImage} alt="product" fallbackComponent={<Icon name="package" width={20} height={20} />} />
    </div>
  );
};
export default ProductImage;
